export enum FaxSendingStep {
  NotStarted,
  Sending,
  SendComplete,
  Success,
  Failure,
}
